import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FF5537",
              d: "M17.5 2c.38 0 .693.282.743.648l.007.102V4H21c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V5c0-.552.448-1 1-1h2.75V2.643c0-.355.336-.643.75-.643.38 0 .693.242.743.556l.007.087V4h9.5V2.75c0-.414.336-.75.75-.75zm3 6.5h-17v12h17v-12zM16 13.75c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L16 15.25H8c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L8 13.75h8zm4.5-8.25h-17V7h17V5.5z",
              transform: "translate(-170 -160) translate(154 152) translate(16 8)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }